import Typography from "@mui/material/Typography";
import type { ReactElement } from "react";
import { CASE_STUDIES } from "../../../common/caseStudies";
import { TilesSection } from "../../components/WhatsNew/TilesSection";
import type { TileProps } from "../../components/WhatsNew/Tile";

const tiles: TileProps[] = CASE_STUDIES.map((caseStudy) => ({
  image: caseStudy.image,
  title: caseStudy.title,
  date: caseStudy.date,
  description: caseStudy.description,
  link: `/case-study/${caseStudy.slug}`,
}));

export default function CaseStudyPage(): ReactElement {
  const numCols = tiles.length === 1 ? 1 : 2;
  return (
    <TilesSection
      cards={tiles}
      cardsPerRow={{
        md: numCols,
        lg: numCols,
      }}
      empty={<Typography variant="h4">No news items available.</Typography>}
      hasHero={tiles.length != 2}
    />
  );
}
